import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 15px;
  overflow-wrap: anywhere;

  .sku {
    font-size: 10px;
    letter-spacing: 0.06em;
    line-height: 12px;
    margin-bottom: 15px;

    .npn {
      margin-left: 25px;
    }
  }

,
`

export const Link = styled(GatsbyLink)`
  font-family: Gotham, Helvetica, Arial, 'sans-serif';
  font-size: 36px;
  font-weight: bold;
  line-height: 1;
  margin-top: 0;
  margin-bottom: 0.42em;
  text-decoration: none;
`
